export const ALL_LOCALESTRING_CULTURE_CODE = "en-US,de-DE";

export type LocaleStringCultureCode = "en-US" | "de-DE" | string;

export const PRODUCT_CODE = "api";

export const DEFAULT_CULTURE_CODE = "en-US";